/* eslint-disable @faire/prefer-arrow-methods */ /**
 * Faire abstraction of date-without-time.
 *
 * See {@link https://docs.google.com/document/d/1XoA1lPt1Hl3rkB3Ggx-sDkErQFVWOXgm-mmJLh4_Lz4}
 */ import { _ as _class_call_check } from "@swc/helpers/_/_class_call_check";
import { _ as _create_class } from "@swc/helpers/_/_create_class";
export var FaireDate = /*#__PURE__*/ function() {
    "use strict";
    function FaireDate(year, month, day) {
        _class_call_check(this, FaireDate);
        this.year = year;
        this.month = month;
        this.day = day;
    }
    var _proto = FaireDate.prototype;
    _proto.valueOf = function valueOf() {
        return this.normalizedUtcTimestamp;
    };
    /**
     * Creates {@link FaireDate} object from timestamp previously saved to server.
     *
     * @param utcTimestamp Normalized UTC timestamp generated by
     *     the {@link normalizedUtcTimestamp} method, or a legacy
     *     timestamp set to 23:59:59 in the browsers timezone.
     */ FaireDate.fromNormalizedOrLocalEndOfDayTimestamp = function fromNormalizedOrLocalEndOfDayTimestamp(utcTimestamp) {
        if (utcTimestamp === undefined) {
            return undefined;
        }
        var d = new Date(utcTimestamp);
        if (d.getUTCHours() !== 12 && d.getUTCSeconds() === 59) {
            // legacy date, created before we only made normalized dates.
            // Previously, the frontend would create dates that were set to 23:59:59
            // in the browsers timezone, and therefore would be early in the morning
            // in the following date when interpreted as UTC (as north american
            // time zones have negative offsets). We should adjust these back by
            // subtracting 12 hours to get the user intended date.
            if (d.getUTCHours() < 12) {
                var TWELVE_HOURS = 12 * 60 * 60 * 1000;
                d = new Date(utcTimestamp - TWELVE_HOURS);
            }
        }
        return new FaireDate(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate());
    };
    /** Creates {@link FaireDate} object from local date object. */ FaireDate.fromLocalDateObject = function fromLocalDateObject(date) {
        return new FaireDate(date.getFullYear(), date.getMonth(), date.getDate());
    };
    _create_class(FaireDate, [
        {
            key: "normalizedUtcTimestamp",
            get: /**
     * Timestamp of YYYY-MM-DD 12:59:59.000 UTC to be stored at server.
     *
     * The server expects normalized UTC timestamps of this format. You ***must***
     * use this method when storing a date to the server.
     */ function get() {
                var d = new Date();
                d.setUTCFullYear(this.year, this.month, this.day);
                d.setUTCHours(12, 59, 59, 0);
                return d.valueOf();
            }
        },
        {
            key: "localDateObject",
            get: /** Local date object for display on the client. */ function get() {
                var d = new Date();
                d.setFullYear(this.year, this.month, this.day);
                d.setHours(12, 59, 59, 0);
                return d;
            }
        }
    ]);
    return FaireDate;
}();
